// Pastell-Typ-Badge — EINE Darstellung für den erkannten Transaktionstyp.
// Volle Pastell-Fläche (TYPE_PASTEL) + weißes Linien-Icon (TYPE_ICON_PATHS) +
// weißes Label (TX_TYPES). Genutzt für gefundene Transaktionen (Import-/Wallet-
// Review) und überall, wo der erkannte Typ als Badge gezeigt wird.
// Reine Anzeige — liest nur aus dem Typ-SSoT, keine Engine-Berührung.
import { F } from '../../styles/theme';
import { TX_TYPES, TYPE_ICON_PATHS, getTxPastel } from '../../utils/transactionTypes';

export default function TypeBadge({ typ, size = 'sm', label: labelOverride }) {
  const color = getTxPastel(typ);
  const icon  = TYPE_ICON_PATHS[typ];
  const label = labelOverride || TX_TYPES[typ]?.label || typ || '—';
  const s = size === 'md'
    ? { font: 11.5, pad: '3px 10px 3px 8px', ic: 12 }
    : { font: 10.5, pad: '3px 9px 3px 7px',  ic: 11 };

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      borderRadius: 999, padding: s.pad,
      background: color, color: '#fff',
      fontFamily: F.family, fontWeight: 700, fontSize: s.font,
      letterSpacing: '0.01em', lineHeight: 1, whiteSpace: 'nowrap', flexShrink: 0,
    }}>
      {icon && (
        <svg width={s.ic} height={s.ic} viewBox="0 0 24 24" fill="none" stroke="#fff"
          strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
          <path d={icon} />
        </svg>
      )}
      {label}
    </span>
  );
}
